import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { ParallaxProvider, ParallaxBanner } from 'react-scroll-parallax';
import { getCategoryIcon } from '../Common/icon-type';
import { getScreenWidth } from '../../utils/helpers';
import debounce from 'just-debounce-it';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';
const Hero = (props) => {
  const [bgImageUrl, setBgImageUrl] = useState('');

  useEffect(() => {
    const { backgrounds } = props;
    let mounted = true;
    handleWindowSizeChange(backgrounds);
    window.addEventListener(
      'resize',
      debounce(() => {
        if (mounted) handleWindowSizeChange(backgrounds);
      }, 400)
    );
    return () => {
      mounted = false;
      window.removeEventListener('resize', handleWindowSizeChange(backgrounds));
    };
  }, []);

  const handleWindowSizeChange = (bg) => {
    setBgImageUrl(getBackgroundImageUrl(bg));
  };

  const getBackgroundImageUrl = (backgrounds) => {
    const jsScreenWidth = getScreenWidth();
    let imageUrl = backgrounds.heroBgMobile;
    if (typeof window !== 'undefined') {
      const mqRetinaDesktop = window.matchMedia('(min-resolution: 192dpi) and (min-width: 1024px)');
      const mqFor4K = window.matchMedia('(min-width: 2560px)');
      const mqForQHD = window.matchMedia('(min-width: 1800px)');
      const mqForDesktop = window.matchMedia('(min-width: 1024px)');
      const mqForTablet = window.matchMedia('(min-width: 600px)');
      if (backgrounds.heroBgFourK && (mqFor4K.matches || mqRetinaDesktop.matches)) {
        // console.log(`backgrounds.heroBgFourK or for retina`);
        imageUrl = backgrounds.heroBgFourK;
      } else if (backgrounds.heroBgQHD && mqForQHD.matches) {
        // console.log(`backgrounds.heroBgQHD`);
        imageUrl = backgrounds.heroBgQHD;
      } else if (mqForDesktop.matches) {
        // console.log(`backgrounds.heroBgDesktop`);
        imageUrl = backgrounds.heroBgDesktop;
      } else if (mqForTablet.matches || jsScreenWidth >= 760) {
        // console.log(`backgrounds.heroBgTablet`);
        imageUrl = backgrounds.heroBgTablet;
      } else {
        // console.log(`backgrounds.heroBgMobile`);
      }
    }
    // console.log('TCL: hero imageUrl', imageUrl);
    if (imageUrl === '') console.warn('Missing Hero Image');
    return imageUrl;
  };

  const getParallaxLayer = (isBgVideo, video) => {
    if (isBgVideo && video) {
      return [
        {
          amount: isParallaxImageScrollDirectionDown ? -0.1 : 0.1, // negative value to scroll up the image when scrolling downwards
          children: (
            <video
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              autoPlay
              loop
              playsInline
              preload="auto"
              muted
              poster={bgImageUrl}
            >
              <source src={video.webm} type="video/webm" />
              <source src={video.mp4} type="video/mp4" />
            </video>
          ),
        },
      ];
    } else {
      return [
        {
          image: bgImageUrl,
          amount: isParallaxImageScrollDirectionDown ? -0.1 : 0.1, // negative value to scroll up the image when scrolling downwards
        },
      ];
    }
  };

  const {
    scrollToContent,
    theme,
    isParallaxImageScrollDirectionDown,
    headerTitle,
    headerSubTitle,
    heroCaption,
    heroCaptionEx,
    category,
    isBgVideo,
    isPost,
    isFeatureBg,
    video,
  } = props;

  return (
    <React.Fragment>
      <ParallaxProvider>
        <ParallaxBanner style={{ height: '100vh' }} layers={getParallaxLayer(isBgVideo, video)}>
          <HeroStyled {...props}>
            {headerTitle ? (
              isPost ? (
                <>
                  <HeroH1Title theme={theme} className="postHeaderTitle">
                    {headerTitle}
                  </HeroH1Title>
                  <HeroH2Title theme={theme}>{headerSubTitle}</HeroH2Title>
                </>
              ) : (
                <>
                  <HeroH1Title theme={theme}>{headerTitle}</HeroH1Title>
                  <HeroH2Title theme={theme}>{headerSubTitle}</HeroH2Title>
                </>
              )
            ) : null}

            {scrollToContent ? (
              <HeroButtonStyled
                theme={theme}
                onClick={scrollToContent}
                aria-label="scroll"
                className={category === '旅行日誌' ? 'travel' : ''}
              >
                {getCategoryIcon(category, true, category === '旅行日誌' ? 'travelIcon' : 'heroIcon')}
              </HeroButtonStyled>
            ) : null}
            {heroCaption && heroCaption !== '' ? (
              heroCaptionEx && heroCaptionEx !== '' ? (
                <p className={heroCaptionStyle}>
                  {heroCaption}
                  <br />
                  {heroCaptionEx}
                </p>
              ) : (
                <p className={heroCaptionStyle}>{heroCaption}</p>
              )
            ) : (
              <svg
                width="1440"
                height="94"
                fill="none"
                viewBox="0 0 1440 94"
                preserveAspectRatio="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1440 34c-180.5 38-275.5 44.5-435.5 54.5 199.83-5.755 336.1-19.224 435.5-40.592V34z"
                  fill="#C6C4B8"
                />
                <path
                  d="M0 10.052C166.542 59.005 463.728 91.58 801.197 91.58L880 91.442s-20.891 1.106-133 1.611C440.885 94.432 185.896 68.373 0 28.714V10.052z"
                  fill="#fff"
                />
                <path
                  d="M0 10.22V0c.344.124 207.024 81.398 733 91 0 0 195.5 4.5 383-10-113.5 9.5-184.254 11.223-319 12C460 93 165.828 58.698 0 10.602v-.382z"
                  fill="#61DAFB"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M0 93.196h1440V47.908c-98.75 21.227-233.87 34.659-431.56 40.477C945.445 91.585 884.811 92.494 797 93c-8.822 0-17.614-.023-26.376-.07-7.385.043-15.25.085-23.624.122-306.115 1.38-561.104-24.679-747-64.338v64.482z"
                />
              </svg>
            )}
          </HeroStyled>
        </ParallaxBanner>
      </ParallaxProvider>
    </React.Fragment>
  );
};

Hero.defaultProps = {
  headerTitle: null,
  headerSubTitle: null,
  isParallaxImageScrollDirectionDown: true,
  scrollToContent: null,
  isBgVideo: false,
  isPost: false,
  video: null,
};

Hero.propTypes = {
  headerTitle: PropTypes.string,
  headerSubTitle: PropTypes.string,
  heroCaption: PropTypes.string,
  heroCaptionEx: PropTypes.string,
  scrollToContent: PropTypes.func,
  backgrounds: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  isParallaxImageScrollDirectionDown: PropTypes.bool,
  category: PropTypes.string,
  isBgVideo: PropTypes.bool,
  video: PropTypes.object,
  isPost: PropTypes.bool,
  isFeatureBg: PropTypes.bool,
};

export default Hero;

const HeroStyled = styled.section`
  align-items: center;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  min-height: 100vh;
  height: 100px;
  width: 100%;
  padding: ${(props) => props.theme.space.inset.l};
  padding-top: ${(props) => props.theme.header.height.homepage};
  position: absolute;
  background-color: ${(props) =>
    props.isBgVideo
      ? 'hsla(0, 0%, 0%, 0.05)'
      : props.isPost
      ? 'hsla(0, 0%, 0%, 0.2)'
      : 'hsla(0, 0%, 0%, 0.1)'};

  svg {
    display: block;
    bottom: -1px;
    position: absolute;
    fill: ${(props) => (props.isFeatureBg ? 'var(--featureExcerptBg)' : 'var(--bg)')};
    fill-opacity: 1;
    width: 100%;
    transition: fill ${(props) => props.theme.time.duration.default} ease-out;
    transform-origin: bottom;
    animation: animateWave 2000ms cubic-bezier(0.23, 1, 0.32, 1) forwards;
    @keyframes animateWave {
      0% {
        transform: scale(1, 0);
      }
      100% {
        transform: scale(1, 1);
      }
    }
  }
`;

const HeroH1Title = styled.h1`
  font-family: 'Niconne', cursive;
  font-weight: normal;
  text-shadow: rgba(0, 0, 0, 0.4) 0px 4px 5px;
  text-align: center;
  font-size: ${(props) => props.theme.hero.h1.size};
  margin: ${(props) => props.theme.space.stack.l};
  color: ${(props) => props.theme.hero.h1.color};
  line-height: ${(props) => props.theme.hero.h1.lineHeight};
  z-index: 1;

  strong {
    position: relative;
  }

  &.postHeaderTitle {
    font-family: 'Open Sans', 'Noto Sans TC', '微軟正黑體', '繁黑體', 'Microsoft JhengHei', 'Microsoft YaHei', '新細明體', PMingLiU, sans-serif;
    font-weight: normal;
    text-shadow: rgba(0, 0, 0, 0.4) 0px 4px 5px;
    font-size: calc(${(props) => props.theme.hero.h1.size} * 0.7)};

    text-align: center;

    margin: ${(props) => props.theme.space.stack.l};
    color: ${(props) => props.theme.hero.h1.color};
    line-height: ${(props) => props.theme.hero.h1.lineHeight};
    z-index: 1;

    strong {
      position: relative;
    }
  }

  @media (min-width: 768px) {
    max-width: 90%;
    font-size: calc(${(props) => props.theme.hero.h1.size} * 1.3);

    &.postHeaderTitle {
      max-width: 90%;
      font-size: calc(${(props) => props.theme.hero.h1.size} * 1);
    }
  }

  @media (min-width: 1024px) {
    max-width: 80%;
    font-size: calc(${(props) => props.theme.hero.h1.size} * 1.5);

    &.postHeaderTitle {
      max-width: 80%;
      font-size: calc(${(props) => props.theme.hero.h1.size} * 1);
    }
  }

  @media (min-width: 1800px) {
    font-size: calc(${(props) => props.theme.hero.h1.size} * 1.7);

    &.postHeaderTitle {
      font-size: calc(${(props) => props.theme.hero.h1.size} * 1);
    }
  }

  @media (min-width: 2560px) {
    font-size: calc(${(props) => props.theme.hero.h1.size} * 2);

    &.postHeaderTitle {
      font-size: calc(${(props) => props.theme.hero.h1.size} * 1);
    }
  }
`;

const HeroH2Title = styled.h2`
  z-index: 1;
  font-weight: normal;
  text-shadow: rgba(0, 0, 0, 0.4) 0px 4px 5px;
  color: #ffffff;

  @media (min-width: 1800px) {
    font-size: calc(${(props) => props.theme.hero.h2.size} * 1.4);
  }

  @media (min-width: 2560px) {
    font-size: calc(${(props) => props.theme.hero.h2.size} * 1.7);
  }
`;

const HeroButtonStyled = styled.button`
  &.travel {
    transform: rotate(90deg);
  }
  background: #70942500;
  border: 0;
  border-radius: 50%;
  font-size: ${(props) => props.theme.font.size.xxl};
  padding: ${(props) => props.theme.space.s} ${(props) => props.theme.space.m};
  cursor: pointer;
  width: ${(props) => props.theme.space.xl};
  height: ${(props) => props.theme.space.xl};

  .travelIcon {
    position: relative;
    top: 5px;
    fill: ${(props) => props.theme.color.neutral.white};
    stroke: ${(props) => props.theme.color.neutral.white};
    animation-duration: ${(props) => props.theme.time.duration.long};
    animation-name: buttonIconMoveX;
    animation-iteration-count: infinite;
    animation-duration: 1.3s;
  }

  .heroIcon {
    position: relative;
    top: 5px;
    fill: ${(props) => props.theme.color.neutral.white};
    stroke: ${(props) => props.theme.color.neutral.white};
    animation-duration: ${(props) => props.theme.time.duration.long};
    animation-name: buttonIconMoveY;
    animation-iteration-count: infinite;
    animation-duration: 1.3s;
  }

  @keyframes buttonIconMoveX {
    0% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(20px);
    }
    100% {
      transform: translateX(0);
    }
  }

  @keyframes buttonIconMoveY {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(20px);
    }
    100% {
      transform: translateY(0);
    }
  }
  @media (min-width: 768px) {
    font-size: ${(props) => props.theme.font.size.xxxl};
  }

  @media (min-width: 1024px) {
    font-size: ${(props) => props.theme.font.size.xxxxl};
  }
  @media (min-width: 2560px) {
    font-size: calc(${(props) => props.theme.font.size.xxxxl} * 1.33);
  }
`;

const heroCaptionStyle = css`
  font-family: 'Noto Sans TC', 'Open Sans', sans-serif;
  right: 0;
  bottom: 0;
  color: #ffffff;
  background-color: rgba(28, 28, 28, 0.75);
  font-size: 12px;
  padding: 10px 15px 10px 10px;
  position: absolute;
`;
